/**
 * ref của các control.
 * Vì sử dụng ở nhiều chỗ nên khai báo chung ở đây
 * nhviet
 */
export const MsControlRef = {
    MsInput: "MsInput",
    MsCombobox: "MsCombobox",
    MsComboboxMultiple: "MsComboboxMultiple",
    MsFileUpload: "MsFileUpload",
    MsDatepicker: "DateBox",
    MsTime: "MsTime", 
    MsTreeSelect: "MsTreeSelect",
    MsTextarea: "MsTextarea",
    MsNumber: "MsNumber",
    MsOrganizationUnit: "MsOrganizationUnit",
    MsHtmlEditor: "MsHtmlEditor",
    MsTagBox: "MsTagBox",
    MsSelectBox: "MsSelectBox",
    MsSelectEmployee: "MsSelectEmployee",
}

export const MsControlFocusRef = {
    MsInput: "MsInputFocus",
    MsCombobox: "MsComboboxFocus",
    MsComboboxMultiple: "MsComboboxMultipleFocus",
    MsFileUpload: "MsFileUploadFocus",
    MsDatepicker: "DateBoxFocus",
    MsTime: "MsTimeFocus", 
    MsTreeSelect: "MsTreeSelectFocus",
    MsTextarea: "MsTextareaFocus",
    MsNumber: "MsNumberFocus",
    MsOrganizationUnit: "MsOrganizationUnitFocus",
    MsHtmlEditor: "MsHtmlEditorFocus",
    MsTagBox: "MsTagBoxFocus",
    MsSelectBox: "MsSelectBoxFocus",
    MsSelectEmployee: "MsSelectEmployeeFocus",
}